// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var DropDownDefaultForm$ReactHooksTemplate = require("./DropDownDefaultForm.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");

function DropDownForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var dropDown = props.dropDown;
  var chooseAnOptionLabel = SurveyLanguage$ReactHooksTemplate.message(language, "choose_an_option");
  var handleOnChange = function ($$event) {
    var choiceId = $$event.target.value;
    if (choiceId === DropDown$ReactHooksTemplate.placeholderOptionValue) {
      return Curry._1(onChange, DropDown$ReactHooksTemplate.clearAnswer(dropDown));
    }
    var selectedChoice = List.find((function (x) {
            return RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(x)) === choiceId;
          }), DropDown$ReactHooksTemplate.choices(dropDown));
    Curry._1(onChange, DropDown$ReactHooksTemplate.setAnswer(dropDown, selectedChoice));
  };
  var matchChoicesWithAnswer = function (choice) {
    var xs = DropDown$ReactHooksTemplate.getAnswer(dropDown);
    if (xs !== undefined) {
      return Belt_List.has(xs, choice, (function (xs, ys) {
                    return Caml_obj.equal(DropDown$ReactHooksTemplate.choiceId(xs), DropDown$ReactHooksTemplate.choiceId(ys));
                  }));
    } else {
      return false;
    }
  };
  var match = DropDown$ReactHooksTemplate.representation(dropDown);
  var backGroundCss;
  switch (match) {
    case "NoBackground" :
    case "TropicalBreezeBackground" :
        backGroundCss = "bg-tropicalbreeze";
        break;
    case "BlackBackground" :
        backGroundCss = "bg-black bg-opacity-50";
        break;
    
  }
  var match$1 = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match$1) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(DropDownDefaultForm$ReactHooksTemplate.make, {
                  dropDown: dropDown,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  var match$2 = DropDown$ReactHooksTemplate.getAnswer(dropDown);
  var answer = DropDown$ReactHooksTemplate.getAnswer(dropDown);
  var tmp;
  if (answer !== undefined) {
    var choice = Belt_List.head(answer);
    tmp = choice !== undefined ? RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(choice)) : DropDown$ReactHooksTemplate.placeholderOptionValue;
  } else {
    tmp = DropDown$ReactHooksTemplate.placeholderOptionValue;
  }
  var answer$1 = DropDown$ReactHooksTemplate.getAnswer(dropDown);
  var tmp$1;
  if (answer$1 !== undefined) {
    var choice$1 = Belt_List.head(answer$1);
    tmp$1 = choice$1 !== undefined && matchChoicesWithAnswer(choice$1) && DropDown$ReactHooksTemplate.getAllowNonSpecifiedText(choice$1) ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("textarea", {
                  className: " " + backGroundCss + " w-full border p-4",
                  placeholder: "Specify if others",
                  rows: 3,
                  onChange: (function (param) {
                      return Curry._1(onChange, DropDown$ReactHooksTemplate.setNotSpecifiedTextForAnswer(dropDown, DropDown$ReactHooksTemplate.setNotSpecifiedText(Utils$ReactHooksTemplate.formTargetValue(param), choice$1)));
                    })
                })
          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
  } else {
    tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                      text: DropDown$ReactHooksTemplate.getTextTranslation(dropDown, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: DropDown$ReactHooksTemplate.getDescriptionTranslation(dropDown, SurveyLanguage$ReactHooksTemplate.name(language)),
                      mandatory: mandatory,
                      surveyTheme: props.surveyTheme,
                      substitutionVariables: substitutionVariables
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: JsxRuntime.jsxs("select", {
                                    children: [
                                      match$2 !== undefined ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("option", {
                                              children: chooseAnOptionLabel,
                                              value: DropDown$ReactHooksTemplate.placeholderOptionValue
                                            }, "0"),
                                      $$Array.of_list(Belt_List.map(DropDown$ReactHooksTemplate.nonEmptyChoices(dropDown), (function (choice) {
                                                  return JsxRuntime.jsx("option", {
                                                              children: DropDown$ReactHooksTemplate.getChoiceTextTranslation(dropDown, choice, SurveyLanguage$ReactHooksTemplate.name(language)),
                                                              value: RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(choice))
                                                            }, RandomId$ReactHooksTemplate.toString(DropDown$ReactHooksTemplate.choiceId(choice)));
                                                })))
                                    ],
                                    className: backGroundCss + " p-2 border border-white-300 rounded\n                      flex w-3/4 mb-2 ",
                                    value: tmp,
                                    onChange: handleOnChange
                                  }),
                              className: "block mb-10-px"
                            }),
                        tmp$1
                      ],
                      className: "flex flex-col"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex flex-col py-8 px-16 small:px-6"
            });
}

var make = DropDownForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
